<template>
  <div class="aw-match">
    <div class="contest-type" :class="contestType == 'robot' ? 'mr-bottom': ''">
      <div :class="contestType == 'jichuang' ? 'type-active right': 'right'"><span @click="changeType('jichuang')">集创赛</span></div>
      <div :class="contestType == 'robot' ? 'type-active left': 'left'"><span @click="changeType('robot')">机器人大赛</span></div>
    </div>
    <div class="aw-match-tab-box" v-if="matchList && matchList.length>0">
        <ul class="match-ul container-center">
            <li v-for="(item, index) in matchList" :key="index" :class="key == item.id ? 'active': ''" @click="chooseItem(item)">{{item.name}}</li>
        </ul>
    </div>

    <!-- 根据需要加载不同的组件 -->
    <PcView2025 v-if="contestType == 'jichuang' && key == '9'"/>
    <!-- PcView2025/PcView2024 小屏使用样式适配，不开发两个组件 -->
    <PcView2024 v-if="contestType == 'jichuang' && key == '8'"/>
    <MobileView2023 v-if="isMobile && contestType == 'jichuang' &&  key == '7'"/>
    <PcView2023 v-if="!isMobile && contestType == 'jichuang' && key == '7'"/>
    <MobileView2022 v-if="isMobile && contestType == 'jichuang' && key == '6'"/>
    <PcView2022 v-if="!isMobile && contestType == 'jichuang' && key == '6'"/>
    <MobileView2021 v-if="isMobile && contestType == 'jichuang' && key == '5'"/>
    <PcView2021 v-if="!isMobile && contestType == 'jichuang' && key == '5'"/>
    <MobileRobot v-if="isMobile && contestType == 'robot'"/>
    <PcRobot v-if="!isMobile && contestType == 'robot'"/>
    

  </div>
</template>

<script>
import PcView2021 from './match/match2021p.vue';
import MobileView2021 from './match/match2021m.vue';
import PcView2022 from './match/match2022p.vue'
import MobileView2022 from './match/match2022m.vue'
import PcView2023 from './match/match2023p.vue'
import MobileView2023 from './match/match2023m.vue'
import PcView2024 from './match/match2024p.vue'
import PcView2025 from './match/match2025p.vue'
import PcRobot from './match/robotP.vue'
import MobileRobot from './match/robotM.vue'
export default {
  name: 'App',
  components: {
    PcView2021,
    MobileView2021,
    PcView2022,
    MobileView2022,
    PcView2023,
    MobileView2023,
    PcView2024,
    PcView2025,
    PcRobot,
    MobileRobot
  },
  data() {
    return {
      matchMap: {
        jichuang: [
          { id: '9', name: '第九届集创赛' },
          { id: '8', name: '第八届集创赛' },
          { id: '7', name: '第七届集创赛' },
          { id: '6', name: '第六届集创赛' },
          { id: '5', name: '第五届集创赛' },
        ],
        robot: [],
      },
      contestType: "jichuang",
      key: '9',
      isMobile: false // 初始值，后面会更新
    }
  },
  mounted() {
    this.checkDevice();
  },
  computed:{
    matchList() {
      return this.matchMap[this.contestType]
    }
  },
  methods: {
    chooseItem(val) {
        this.key = val.id
    },
    checkDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      this.isMobile = /phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone/i.test(userAgent);
    },
    changeType(type){
      this.contestType = type
      this.key = '9'
    }
  }
}
</script>